/**
 * StatusPill — pastille de statut (refresh design, 2026-07).
 * Volontairement VIVE (le peps des badges est un atout, cf. reco design). Tons
 * cohérents à travers tous les contextes ; option dégradé pour l'état « actif ».
 */
import * as React from "react";

type Tone = "wait" | "success" | "danger" | "info";

const TONES: Record<Tone, { bg: string; fg: string }> = {
  wait:    { bg: "#F6C847", fg: "#5A4400" }, // or vif (ex. « À accepter »)
  success: { bg: "#DDF3E6", fg: "#1E7A3C" }, // vert (ex. « Gagné »)
  danger:  { bg: "#FBE0DE", fg: "#C0423F" }, // corail (ex. « Perdu »)
  info:    { bg: "#E7ECF7", fg: "#384872" }, // navy (neutre)
};

export function StatusPill({
  children,
  tone = "info",
  gradientVar,
}: {
  children: React.ReactNode;
  tone?: Tone;
  /** Si fourni : pastille en dégradé, texte blanc (état « actif », ex. « À toi de jouer »). */
  gradientVar?: string;
}) {
  const style: React.CSSProperties = gradientVar
    ? { backgroundImage: gradientVar, color: "#fff" }
    : { background: TONES[tone].bg, color: TONES[tone].fg };
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-bold whitespace-nowrap"
      style={style}
    >
      {children}
    </span>
  );
}
